<script lang="ts">
  import Button from '../../components/ui/Button.svelte';
  import Dialog from '../../components/ui/Dialog.svelte';
  import type { DialogRequest } from '../context.js';

  interface Props {
    request: DialogRequest | null;
    onclose: () => void;
  }

  let { request, onclose }: Props = $props();

  let open = $derived(!!request);

  function handleConfirm() {
    request?.onconfirm?.();
    onclose();
  }

  function handleCancel() {
    request?.oncancel?.();
    onclose();
  }
</script>

<Dialog
  {open}
  title={request?.title ?? ''}
  description={request?.description ?? ''}
  onclose={onclose}
>
  {#snippet footer()}
    {#if request?.cancelLabel}
      <Button variant="secondary" onclick={handleCancel}>{request.cancelLabel}</Button>
    {/if}
    <Button onclick={handleConfirm}>{request?.confirmLabel ?? 'OK'}</Button>
  {/snippet}
</Dialog>
